module.exports = __webpack_public_path__ + "static/media/traffic-light.262bd006.svg";